import React from 'react';
import { Modal } from 'components/Modal';
import { notifyNoAccess } from 'connectors/bugsnag';
import Cookie from 'js-cookie';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { authenticationState, loadingState } from 'state/atoms';
import { ACCOUNT_SEARCH_URL, USER_REQUEST_PATH_COOKIE } from 'utils/constants';
import { emptyAccessConfig, noAccessConfig, notAuthenticatedConfig } from './modalConfigs';
import { useAccountLoad } from './useAccountLoad';
import { useSessionController } from './useSessionController';

const getModalConfig = ({
  isAuthenticated,
  eCommerceAccess,
  commerceComplete,
  hasBillToAddress,
}) => {
  if (!isAuthenticated) {
    return notAuthenticatedConfig;
  } else if (!eCommerceAccess.length || !commerceComplete || !hasBillToAddress) {
    return emptyAccessConfig;
  } else {
    return noAccessConfig;
  }
};

const AuthOverlay = ({ children }) => {
  const { pathname } = useLocation();
  const setLoading = useSetRecoilState(loadingState);
  const authData = useRecoilValue(authenticationState);

  const [{ commerceComplete, hasBillToAddress }] = useAccountLoad(authData);

  const { canAccessRma, endCustomerAccountId } = authData;

  useSessionController();

  useEffect(() => {
    Cookie.remove(USER_REQUEST_PATH_COOKIE, { domain: '.calix.com' });
  }, []);

  useEffect(() => {
    const isCaseDetailsPage = pathname.match(/\/case\/\w+$/g);

    // Notify when user without permission tries to access case details
    if (isCaseDetailsPage && !canAccessRma) {
      notifyNoAccess(authData);
    }
  }, [canAccessRma, pathname, authData]);

  if (canAccessRma && !endCustomerAccountId) {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.assign(`${ACCOUNT_SEARCH_URL}?returnUrl=${returnUrl}`);
    return null;
  }

  const renderModal = () => {
    setLoading(false); // Disable the global loading state when rendering the modal

    return (
      <Modal
        isOpen
        position="top"
        {...getModalConfig({ ...authData, commerceComplete, hasBillToAddress })}
      />
    );
  };

  return canAccessRma && commerceComplete && hasBillToAddress ? children : renderModal();
};

export { AuthOverlay };
